
var stache = require('can/view/stache/stache');
module.exports = stache("{{#if wgtUrl}}\r\n    <div class=\"s-wgt-iframe-container\" >\r\n        <iframe src=\"{{wgtUrl}}\" frameborder=\"0\" scrolling=\"no\" class=\"s-wgt-iframe\"></iframe>\r\n    </div>\r\n{{/if}}\r\n");